import React from 'react';
interface CtaButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
}
export function CtaButton({
  children,
  className = '',
  href = '#precio'
}: CtaButtonProps) {
  return <a href={href} className={`inline-flex items-center justify-center rounded-xl bg-accent px-6 py-4 text-base font-bold text-white shadow-lg shadow-accent/20 transition-all hover:bg-accent-dark active:scale-[0.98] sm:text-lg ${className}`} data-id="element-52" data-mp="hk5ipmc37hse">
      {children}
    </a>;
}